export default __webpack_public_path__ + "static/KPOINT_logo_new-7b58d960aaccaf7a8603aa1daf200350.png";